import gql from 'graphql-tag';

import listingQuery from './listingQuery';
import favoriteIdsQuery from './favoriteIdsQuery';
import listingStatistics from './listingStatistics';

const QUERY_LISTING = gql`
  query Listing($id: ID!, $locale: String!) {
    ${listingQuery}
    ${favoriteIdsQuery}
    ${listingStatistics}
    isLogged
  }
`;

export const getListing = client => (id, locale) =>
  client.query({
    query: QUERY_LISTING,
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
    variables: {
      id,
      locale
    }
  });

const QUERY_LAST_UNPUBLISHED_DATE = gql`
  query LastUnpublishedDate($id: ID!) {
    ad(id: $id) {
      lastUnpublishedDate
    }
  }
`;

export const getLastUnpublishedDate = client => id =>
  client.query({
    query: QUERY_LAST_UNPUBLISHED_DATE,
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
    variables: { id }
  });

export default {
  getListing
};
